import { useEffect, useRef } from 'react';

const BackgroundEffect = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrameId;

    // Ajusta o canvas para tela cheia
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };

    window.addEventListener('resize', resizeCanvas);
    resizeCanvas();

    // Configuração das partículas "IRRF"
    const particles = [];
    const particleCount = 50;

    class Particle {
      constructor() {
        this.reset();
      }

      reset() {
        this.size = Math.random() * 20 + 10; // Tamanho variável
        this.x = Math.random() * canvas.width;
        this.y = -this.size;
        this.speed = Math.random() * 1 + 0.5;
        this.opacity = Math.random() * 0.6 + 0.2;
        this.rotation = Math.random() * 360;
        this.rotationSpeed = (Math.random() - 0.5) * 2;
      }

      update() {
        this.y += this.speed;
        this.rotation += this.rotationSpeed;

        if (this.y > canvas.height + this.size) {
          this.reset();
        }
      }

      draw() {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate((this.rotation * Math.PI) / 180);
        ctx.font = `${this.size}px 'Arial'`;
        ctx.fillStyle = `rgba(99, 102, 241, ${this.opacity})`; // indigo-500
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        ctx.fillText('IRRF', 0, 0);
        ctx.restore();
      }
    }

    // Inicializa as partículas
    for (let i = 0; i < particleCount; i++) {
      particles.push(new Particle());
    }

    // Gradiente de fundo
    const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    gradient.addColorStop(0, '#020617'); // slate-950
    gradient.addColorStop(1, '#0f172a'); // slate-900

    // Função de animação
    const animate = () => {
      ctx.fillStyle = gradient;
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      particles.forEach(particle => {
        particle.update();
        particle.draw();
      });

      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    // Cleanup
    return () => {
      window.removeEventListener('resize', resizeCanvas);
      cancelAnimationFrame(animationFrameId);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="fixed inset-0 -z-10"
      style={{ background: 'linear-gradient(to bottom right, #020617, #0f172a)' }}
    />
  );
};

export default BackgroundEffect;
